import { Component, useEffect, useState } from "react";
import Api, { exceptionNotificationAPI } from "./api";
import Swal from 'sweetalert2';
import { useAuth } from '../hooks/auth';
import { success_message, info_message, error_message } from '../components/Toast/index';
import { func } from "prop-types";
import { toleranceValidations } from "./tolerance";
import GetTypeInput from "../components/FormInput/set";



// const [readConsent, setReadConsent] = useState(null);
// const { userRoles } = useAuth();
// const history = useHistory();

var answersToBeValited = [];

const COLUMN_ROW_TYPES = {
    'Simple': 1,
    'Country': 2,
    'FuelType': 3,
    'CultureType': 4,
    'Year': 5,
}

export const setNumber = ({ subSectionKPI, ref, value, column, row, fuelTypeID, countryID, isCultureType, cultureTypeID, totalSubSectionKPIID, moduleObject, setModuleObject, subSectionKPIs, yearID, setKPIEvidences, kpiEvidences = null, setSubsectionKPIs }) => {
    setFormAnswers(
        {
            'moduleObject': moduleObject,
            'subSectionKPI': subSectionKPI,
            'ref': ref,
            'value': value != null ? value : "",
            'column': column,
            'row': row,
            'fuelTypeID': fuelTypeID,
            'countryID': countryID,
            'isCultureType': isCultureType,
            'cultureTypeID': cultureTypeID,
            'totalSubSectionKPIID': totalSubSectionKPIID,
            'setModuleObject': setModuleObject,
            'subSectionKPIs': subSectionKPIs,
            'yearID': yearID,
            'kpiEvidences': kpiEvidences,
            'setKPIEvidences': setKPIEvidences,
            'setSubsectionKPIs': setSubsectionKPIs
        });
};

export const setText = ({ subSectionKPI, ref, value, column, row, fuelTypeID, curingBarnID, countryID, isCultureType, cultureTypeID, totalSubSectionKPIID, moduleObject, setModuleObject, subSectionKPIs, yearID, setKPIEvidences, kpiEvidences = null, listTreeItemID, setSubsectionKPIs, listTreeAttrsCachePatch }) => {
    setFormAnswers(
        {
            'moduleObject': moduleObject,
            'subSectionKPI': subSectionKPI,
            'ref': ref,
            'text': value != null ? value : "",
            'column': column,
            'row': row,
            'fuelTypeID': fuelTypeID,
            'curingBarnID': curingBarnID,
            'countryID': countryID,
            'isCultureType': isCultureType,
            'cultureTypeID': cultureTypeID,
            'totalSubSectionKPIID': totalSubSectionKPIID,
            'setModuleObject': setModuleObject,
            'subSectionKPIs': subSectionKPIs,
            'yearID': yearID,
            'kpiEvidences': kpiEvidences,
            'setKPIEvidences': setKPIEvidences,
            'setSubsectionKPIs': setSubsectionKPIs,
            'listTreeItemID': listTreeItemID,
            'listTreeAttrsCachePatch': listTreeAttrsCachePatch
        });
};

export const setComment = ({ subSectionKPI, ref, value, column, row, fuelTypeID, curingBarnID, countryID, isCultureType, cultureTypeID, totalSubSectionKPIID, moduleObject, setModuleObject, subSectionKPIs, yearID }) => {
    setFormAnswers(
        {
            'moduleObject': moduleObject,
            'subSectionKPI': subSectionKPI,
            'ref': ref,
            'comment': value != null ? value : "",
            'column': column,
            'row': row,
            'fuelTypeID': fuelTypeID,
            'curingBarnID': curingBarnID,
            'countryID': countryID,
            'isCultureType': isCultureType,
            'cultureTypeID': cultureTypeID,
            'totalSubSectionKPIID': totalSubSectionKPIID,
            'setModuleObject': setModuleObject,
            'subSectionKPIs': subSectionKPIs,
            'yearID': yearID
        });
};

export const setFile = ({ subSectionKPI, ref, value, column, row, fuelTypeID, curingBarnID, countryID, isCultureType, cultureTypeID, totalSubSectionKPIID, moduleObject, setModuleObject, subSectionKPIs }) => {
    setFormAnswers(
        {
            'moduleObject': moduleObject,
            'subSectionKPI': subSectionKPI,
            'ref': ref,
            'file': value != null ? value : "",
            'column': column,
            'row': row,
            'fuelTypeID': fuelTypeID,
            'curingBarnID': curingBarnID,
            'countryID': countryID,
            'isCultureType': isCultureType,
            'cultureTypeID': cultureTypeID != null ? cultureTypeID : "",
            'totalSubSectionKPIID': totalSubSectionKPIID,
            'setModuleObject': setModuleObject,
            'subSectionKPIs': subSectionKPIs
        });
};

export const removeFile = ({ subSectionKPI, ref, value, column, row, fuelTypeID, curingBarnID, countryID, isCultureType, cultureTypeID, totalSubSectionKPIID, moduleObject, setModuleObject, subSectionKPIs, deleteFile }) => {
    setFormAnswers(
        {
            'moduleObject': moduleObject,
            'subSectionKPI': subSectionKPI,
            'ref': ref,
            'file': value != null ? value : "",
            'column': column,
            'row': row,
            'fuelTypeID': fuelTypeID,
            'curingBarnID': curingBarnID,
            'countryID': countryID,
            'isCultureType': isCultureType,
            'cultureTypeID': cultureTypeID != null ? cultureTypeID : "",
            'totalSubSectionKPIID': totalSubSectionKPIID,
            'setModuleObject': setModuleObject,
            'subSectionKPIs': subSectionKPIs,
            'deleteFile': deleteFile
        });
};

const setFormAnswers = ({ moduleObject, setModuleObject, subSectionKPI, ref, value = null, text = null, comment = null, file = null, column = null, row = null, subSectionKPIs, curingBarnID, cultureTypeID, yearID, setKPIEvidences, kpiEvidences = null, deleteFile = null, setSubsectionKPIs, listTreeItemID, listTreeAttrsCachePatch = null }) => {
    var newAnswers = moduleObject.answers;
    var myAnswer = getAnswers(
        {
            'newAnswers': newAnswers,
            'ref': ref,
            'subSectionKPI': subSectionKPI,
            'row': row,
            'column': column
        })[0];
    var answerExists = false;

    var subSectionKPIColumn = moduleObject.columnRows.find(x => x.columnRowID == subSectionKPI.columnRowID);

    var extraIdType = getExtraIdType(subSectionKPIColumn, newAnswers, subSectionKPI.refNumber, column, row, text);


    if (myAnswer != null) {
        if (value != null)
            myAnswer.numberValue = value;
        if (text != null) {
            myAnswer.textValue = text;
            if (text === '')
                myAnswer.numberValue = null;
        }
        if (comment != null)
            myAnswer.comment = comment;
        if (file != null) {
            if (deleteFile) {
                myAnswer.file.find(e => e.file == file).isDeleted = deleteFile
            } else {
                if (Array.isArray(myAnswer.file)) {
                    myAnswer.file.push({ file, isDeleted: false })
                } else {
                    myAnswer.file = [{ file, isDeleted: false }];
                }
            }
        }
        if (row != null)
            myAnswer.row = row;
        if (curingBarnID != null)
            myAnswer.curingBarnID = curingBarnID;
        if (cultureTypeID != null)
            myAnswer.cultureTypeID = cultureTypeID;
        if (yearID != null)
            myAnswer.yearID = yearID;
        if (listTreeItemID !== undefined)
            myAnswer.listTreeItemID = listTreeItemID;
        if (extraIdType != null) {
            myAnswer[extraIdType.type] = extraIdType.value * 1;
        }
        myAnswer.isFromFSMIntegration = false;
        answerExists = true;
        if ((value === '' && text == null && comment == null && file == null) || (text === '' && value == null && comment == null && file == null)) {
            myAnswer.comment = null;
            myAnswer.file = null;
        }
    } else if (value != null || text != null || file != null || comment != null) {
        myAnswer = {
            "subSectionKPIID": subSectionKPI.subSectionKPIID,
            "refNumber": ref,
            "subSectionID": subSectionKPI.subSectionID,
            "numberValue": value,
            "textValue": text,
            "curingBarnID": curingBarnID,
            "cultureTypeID": cultureTypeID,
            "comment": comment,
            "column": column,
            "row": row,
            "file": file ? [{ file, isDeleted: false }] : null,
            "yearID": yearID,
            "listTreeItemID": listTreeItemID !== undefined ? listTreeItemID : null
        }
        if (extraIdType != null) {
            myAnswer[extraIdType.type] = extraIdType.value * 1;
        }
        // Ensure we don't include a thriveValueID for new answers
        // The backend will assign it when saving
        answerExists = true;
    }
    validateEvidence({
        subSectionKPIID: subSectionKPI.subSectionKPIID,
        value: value ?? '',
        column, row, curingBarnID,
        extraTypeID: extraIdType,
        kpiEvidences, setKPIEvidences,
        subSectionKPIs,
        answers: newAnswers,
    });

    if (subSectionKPIs && kpiEvidences && setKPIEvidences) {
        const changedRef = String(subSectionKPI.refNumber).trim();
        subSectionKPIs
            .filter(ssk =>
                String(ssk.evidenceRefNumberValidate ?? ssk.EvidenceRefNumberValidate ?? '').trim() === changedRef
            )
            .forEach(ssk => {
                newAnswers
                    .filter(a => a.subSectionKPIID == ssk.subSectionKPIID)
                    .forEach(ans => {
                        const sskColumn = moduleObject.columnRows.find(x => x.columnRowID == ssk.columnRowID);
                        validateEvidence({
                            subSectionKPIID: ssk.subSectionKPIID,
                            value: ans.numberValue ?? ans.textValue ?? '',
                            column: ans.column,
                            row: ans.row,
                            extraTypeID: getExtraIdType(sskColumn, newAnswers, ssk.refNumber, ans.column, ans.row),
                            kpiEvidences, setKPIEvidences, subSectionKPIs, answers: newAnswers,
                        });
                    });
            });
    }

    var notChangedAnswers = getNotChangedAnswers(newAnswers, subSectionKPI, ref, column, row);

    if (answerExists && myAnswer) {
        // Include answer if it has value, text, file, or comment
        var hasValue = (myAnswer.numberValue != null && (myAnswer.numberValue + "") != "");
        var hasText = (myAnswer.textValue != null && (myAnswer.textValue + "") != "");
        var hasFile = (myAnswer.file != null && Array.isArray(myAnswer.file) && myAnswer.file.length > 0 && myAnswer.file.some(f => !f.isDeleted));
        var hasComment = (myAnswer.comment != null && (myAnswer.comment + "") != "");
        var hasInputValue = (value != null && (value + "") != "") || (text != null && text != "");
        
        if (((myAnswer.numberValue != null && (myAnswer.numberValue + "") != "") || myAnswer.textValue != null && (myAnswer.textValue + "") != "") || (value != null && (value + "") != "") || (text != null && text != "")) {
            newAnswers = [...notChangedAnswers, myAnswer];
            answersToBeValited.push({ 'subSectionKPI': subSectionKPI, ...myAnswer });
        }
        else {
            newAnswers = notChangedAnswers;

            //Remove alertas respostas vazias
            var querySelector = `#subSectionKPI_${subSectionKPI.subSectionKPIID}_${subSectionKPI.columnRowID}`;

            if (column != null) {
                querySelector += `_c${column}`;
            }
            if (row != null) {
                querySelector += `_r${row}`;
            }
            var alert = document.querySelector(`${querySelector}_alert`);
            var input = document.querySelector(querySelector);

            input != null && input.classList.remove("alert-input");
            alert != null && alert.classList.add("hide");

        }
    }
    else {
        newAnswers = notChangedAnswers;
    }

    LinkedTolerancesToValidate(subSectionKPI, newAnswers, subSectionKPIs, column, row);

    const mergedListTreeAttrsCache = {
        ...(moduleObject.listTreeItemAttrsCache || {}),
        ...(listTreeAttrsCachePatch || {}),
    };
    const moduleForCalc = {
        ...moduleObject,
        answers: newAnswers,
        listTreeItemAttrsCache: mergedListTreeAttrsCache,
    };

    var newAnswersWithCalculatedValues = [...refNumberCalculationsDependencies(subSectionKPI, newAnswers, subSectionKPIs, column, row, moduleObject.version, moduleObject.columnRows, moduleForCalc, setKPIEvidences, kpiEvidences)];

    answersToBeValited.map((answer) => {
        if (answer != null) {
            const invalid = toleranceValidations({
                'subSectionKPI': answer.subSectionKPI,
                'column': answer.column,
                'row': answer.row,
                'value': answer.numberValue,
                'text': answer.textValue,
                'newAnswers': newAnswersWithCalculatedValues,
                'subSectionKPIs': subSectionKPIs,
                'moduleObject': moduleObject
            });
            const answerInState = newAnswersWithCalculatedValues.find(
                a => a.subSectionKPIID == answer.subSectionKPIID && a.refNumber == answer.refNumber && a.column == answer.column && a.row == answer.row
            );
            if (answerInState != null) {
                answerInState.toleranceInvalid = invalid;
            }
        }
    });

    answersToBeValited = [];


    handleDynamicBlocking(moduleObject, text, value, subSectionKPI, subSectionKPIs, row, column);

    setModuleObject({
        ...moduleObject,
        answers: newAnswersWithCalculatedValues,
        listTreeItemAttrsCache: mergedListTreeAttrsCache,
    });

};

function normalizeDynamicBlockRef(ref) {
    const n = Number(ref);
    return Number.isNaN(n) ? ref : n;
}

export function getValToCheckFromStoredAnswer(answer) {
    if (!answer) return null;
    const t = answer.textValue;
    const v = answer.numberValue;
    if (t != null && t !== '') {
        // Versões anteriores podiam persistir um multiselect vazio como texto ("[]").
        // Uma lista sem itens não representa uma resposta preenchida.
        if (typeof t === 'string') {
            try {
                const parsed = JSON.parse(t);
                if (Array.isArray(parsed) && parsed.length === 0) return null;
            } catch {
                // Texto comum não é JSON e continua sendo um valor válido.
            }
        }
        return t;
    }
    // Select/texto limpo no UI: textValue '' não deve cair no numberValue antigo (bloqueio ficava ativo até novo save)
    if (t === '') return null;
    if (v != null && (v + '') !== '') return v;
    return null;
}

/**
 * Localiza a resposta do KPI-gatilho para regras de bloqueio.
 * Com várias colunas (Value / % por grupo): tenta a mesma coluna da vítima; depois resposta sem coluna
 * (gatilho partilhado); por fim qualquer resposta na mesma row — senão o bloqueio falha só no select da outra coluna.
 */
export function findAnswerForDynamicBlock(moduleObject, refNumber, row, column) {
    const list = (moduleObject.answers || []).filter(x => x.refNumber == refNumber);
    if (!list.length) return null;

    const skipRow = row == null || row === undefined;
    const pool = list.filter(x =>
        skipRow || x.row == null || x.row === undefined || x.row == row
    );
    const usePool = pool.length ? pool : list;

    if (column != null && column !== undefined) {
        const exact = usePool.find(x => x.column == column);
        if (exact) return exact;
        const sharedCol = usePool.find(x => x.column == null || x.column === undefined);
        if (sharedCol) return sharedCol;
        return usePool[0] || list[0];
    }

    return usePool.find(x => x.column == null || x.column === undefined) || usePool[0] || list[0];
}

/** Agrega refNumbers ainda bloqueados por qualquer KPI com regras em dynamicBlockKpis (outros campos + valor atual do edit). */
function collectActiveDynamicBlockRefNumbers(moduleObject, subSectionKPIs, row, column, sourceBeingEdited, editText, editValue) {
    const blocked = new Set();
    const dbk = moduleObject.dynamicBlockKpis;
    if (!dbk) return blocked;

    for (const sourceRefKey of Object.keys(dbk)) {
        const rules = dbk[sourceRefKey] || [];
        if (!rules.length) continue;

        const ssk = subSectionKPIs.find(x => x.refNumber == sourceRefKey);
        if (!ssk) continue;

        let valToCheck;
        if (sourceBeingEdited != null && ssk.refNumber == sourceBeingEdited.refNumber) {
            valToCheck = editText != null && editText !== '' ? editText : editValue;
        } else {
            valToCheck = getValToCheckFromStoredAnswer(findAnswerForDynamicBlock(moduleObject, ssk.refNumber, row, column));
        }

        const matching = rules.filter(rule => applyRule(valToCheck, rule.answerToBlock));
        matching.forEach(r => {
            (r.refNumbersToBlock || []).forEach(refToBlock => {
                blocked.add(normalizeDynamicBlockRef(refToBlock));
            });
        });
    }
    return blocked;
}

function filterRefsToUnblock(candidateRefs, stillBlockedSet) {
    return candidateRefs.filter(r => !stillBlockedSet.has(normalizeDynamicBlockRef(r)));
}

function handleDynamicBlocking(moduleObject, text, value, subSectionKPI, subSectionKPIs, row = null, column = null) {
    const rules = (moduleObject.dynamicBlockKpis && moduleObject.dynamicBlockKpis[subSectionKPI.refNumber]) || [];

    // Qualquer valor válido (texto tem prioridade sobre value)
    const valToCheck = (text != null && text !== '') ? text : value;

    const stillBlockedGlobally = () =>
        collectActiveDynamicBlockRefNumbers(moduleObject, subSectionKPIs, row, column, subSectionKPI, text, value);

    // Se não tiver valor, re-habilita tudo (passa todos os possíveis refs e disable=false)
    if ((valToCheck == null || valToCheck === '') && !rules.filter(rule => rule.answerToBlock == "null")[0]) {
        const allRefs = rules.flatMap(r => r.refNumbersToBlock || []);
        const toUnblock = filterRefsToUnblock(allRefs, stillBlockedGlobally());
        if (toUnblock.length > 0) {
            dynamicallyBlockFields({
                subSectionKPI,
                subSectionKPIs,
                refNumbersToBlock: toUnblock,
                disable: false,
                moduleObject,
                row,
                column,
            });
        }
        return;
    }
    // Regras que batem
    const matching = rules.filter(rule =>
        applyRule(valToCheck, rule.answerToBlock)
    );
    // refs que devem ser bloqueados agora
    const refsToBlock = matching.flatMap(r => r.refNumbersToBlock || []);
    // todos os refs possíveis, pra quando for re-habilitar
    const allPossibleRefs = rules.flatMap(r => r.refNumbersToBlock || []);

    if (refsToBlock.length > 0) {
        // bloquear só os que batem
        dynamicallyBlockFields({
            subSectionKPI,
            subSectionKPIs,
            refNumbersToBlock: refsToBlock,
            disable: true,
            moduleObject,
            row,
            column,
        });
    } else {
        // não bateu nenhuma: re-habilita só os que não seguem bloqueados por outra regra
        const toUnblock = filterRefsToUnblock(allPossibleRefs, stillBlockedGlobally());
        if (toUnblock.length > 0) {
            dynamicallyBlockFields({
                subSectionKPI,
                subSectionKPIs,
                refNumbersToBlock: toUnblock,
                disable: false,
                moduleObject,
                row,
                column,
            });
        }
    }
}

export function validateEvidence({ subSectionKPIID, value, column, row, curingBarnID, extraTypeID, setKPIEvidences, kpiEvidences, subSectionKPIs, answers }) {
    if (!kpiEvidences?.length || !setKPIEvidences) return;

    const evidences = kpiEvidences.filter(d =>
        d.subSectionKPIID == subSectionKPIID &&
        d.file &&
        d.row == (row ?? null) &&
        d.column == (column ?? null) &&
        d.curingBarnID == (curingBarnID ?? null) &&
        (extraTypeID != null ? d[extraTypeID.type] == extraTypeID.value : true)
    );
    if (!evidences.length) return;

    let refRaw = '';
    let liveRef = null;
    if (subSectionKPIs && answers) {
        const ownerSSK = subSectionKPIs.find(x => x.subSectionKPIID == subSectionKPIID);
        refRaw = String(ownerSSK?.evidenceRefNumberValidate ?? ownerSSK?.EvidenceRefNumberValidate ?? '').trim();
        if (refRaw !== '') {
            const refAnswer = answers.find(x => String(x.refNumber).trim() === refRaw);
            liveRef = refAnswer?.numberValue ?? refAnswer?.textValue ?? null;
        }
    }

    const toUpdate = [];
    evidences.forEach(evidence => {
        const ownValueMatches =
            RoundFixedNumber(parseFloat(evidence.value), 2) === RoundFixedNumber(parseFloat(value), 2);

        const refValueMatches = (refRaw === '' || liveRef == null)
            ? true
            : RoundFixedNumber(parseFloat(liveRef), 2) === RoundFixedNumber(parseFloat(evidence.farmersCount), 2);

        const shouldBeValid = ownValueMatches && refValueMatches;
        if (evidence.isValidated !== shouldBeValid) {
            evidence.isValidated = shouldBeValid;
            toUpdate.push(evidence);
        }
    });

    if (!toUpdate.length) return;

    const updatedIds = new Set(toUpdate.map(e => e.evidenceAuditID));
    const unchanged = kpiEvidences.filter(x => !updatedIds.has(x.evidenceAuditID));

    Promise.all(toUpdate.map(e => Api.post('EvidenceAudit/UpdateStatus', e)))
        .then(results => {
            if (results.every(r => r?.data?.response)) {
                setKPIEvidences([...unchanged, ...toUpdate]);
            }
        })
        .catch(exceptionNotificationAPI);
}

// Extrai todos os refNumbers de uma string de cálculo
function extractRefNumbersFromCalculation(calculation) {
    if (!calculation) return [];
    
    // Regex para encontrar padrões [número] ou [número.número]
    var regex = /\[(\d+(?:\.\d+)?)\]/g;
    var matches = [];
    var match;
    
    while ((match = regex.exec(calculation)) !== null) {
        var refNumber = parseInt(match[1].split('.')[0]); // Pega apenas a parte inteira antes do ponto
        if (!matches.includes(refNumber)) {
            matches.push(refNumber);
        }
    }
    
    return matches;
}

// Constrói o grafo de dependências e retorna a ordem topológica
function topologicalSort(refNumberCalculations, subSectionKPIs) {
    // Mapa: refNumber -> lista de refNumbers que dependem dele
    var dependencyGraph = {};
    // Mapa: refNumber -> lista de refNumbers dos quais ele depende
    var dependsOn = {};
    // Set de todos os refNumbers que são cálculos
    var calculationRefNumbers = new Set();
    
    // Inicializar estruturas
    refNumberCalculations.forEach(ssk => {
        var refNum = ssk.refNumber;
        calculationRefNumbers.add(refNum);
        dependencyGraph[refNum] = [];
        dependsOn[refNum] = [];
    });
    
    // Construir o grafo de dependências
    refNumberCalculations.forEach(ssk => {
        var dependencies = [];
        if (ssk.calculation) {
            dependencies = extractRefNumbersFromCalculation(ssk.calculation);
        }
        if (ssk.listTreeAttrSourceRefNumber) {
            var depInt = parseInt(String(ssk.listTreeAttrSourceRefNumber).trim().split('.')[0], 10);
            if (!Number.isNaN(depInt) && !dependencies.includes(depInt)) {
                dependencies.push(depInt);
            }
        }
        dependsOn[ssk.refNumber] = dependencies;

        dependencies.forEach(depRef => {
            if (!dependencyGraph[depRef]) {
                dependencyGraph[depRef] = [];
            }
            dependencyGraph[depRef].push(ssk.refNumber);
        });
    });
    
    // Ordenação topológica usando Kahn's algorithm
    var sorted = [];
    var inDegree = {};
    var queue = [];
    
    // Calcular grau de entrada (quantas dependências cada nó tem)
    calculationRefNumbers.forEach(refNum => {
        inDegree[refNum] = dependsOn[refNum].filter(dep => calculationRefNumbers.has(dep)).length;
        if (inDegree[refNum] === 0) {
            queue.push(refNum);
        }
    });
    
    // Processar nós sem dependências
    while (queue.length > 0) {
        var current = queue.shift();
        sorted.push(current);
        
        // Reduzir grau de entrada dos dependentes
        if (dependencyGraph[current]) {
            dependencyGraph[current].forEach(dependent => {
                inDegree[dependent]--;
                if (inDegree[dependent] === 0) {
                    queue.push(dependent);
                }
            });
        }
    }
    
    // Se houver ciclos ou nós não processados, adicionar os restantes
    // Primeiro, tentar manter a ordem original para os não processados
    var remaining = [];
    calculationRefNumbers.forEach(refNum => {
        if (!sorted.includes(refNum)) {
            remaining.push(refNum);
        }
    });
    
    // Se houver nós restantes, adicioná-los (pode indicar ciclo ou erro)
    if (remaining.length > 0) {
        // Ordenar os restantes por refNumber para manter consistência
        remaining.sort((a, b) => a - b);
        sorted = sorted.concat(remaining);
    }
    
    // Retornar SubSectionKPIs ordenados
    var sortedSubSectionKPIs = [];
    sorted.forEach(refNum => {
        var ssk = refNumberCalculations.find(x => x.refNumber === refNum);
        if (ssk) {
            sortedSubSectionKPIs.push(ssk);
        }
    });
    
    // Adicionar qualquer SubSectionKPI que não foi incluído (caso de erro)
    refNumberCalculations.forEach(ssk => {
        if (!sortedSubSectionKPIs.find(x => x.refNumber === ssk.refNumber)) {
            sortedSubSectionKPIs.push(ssk);
        }
    });
    
    return sortedSubSectionKPIs;
}

export const refNumberCalculationsDependencies = (subSectionKPI, answers, subSectionKPIs = null, column = null, row = null, version, columnRows, moduleObject, setKPIEvidences = null, kpiEvidences = null) => {
    var refNumberCalculations = null;
    var formattedRefNumber = "[" + subSectionKPI.refNumber + "]";
    if (subSectionKPIs != null) {
        refNumberCalculations = subSectionKPIs.filter(x =>
            ((x.inputCalc === 'Calculation' && (x.calculation != null && x.calculation.indexOf(formattedRefNumber) > -1))
                || (x.inputCalc === 'DisplayText' && x.listTreeAttrSourceRefNumber != null
                    && refNumbersLooseEqual(x.listTreeAttrSourceRefNumber, subSectionKPI.refNumber))
            ),
        );
    }

    // Ordenação topológica baseada em dependências ao invés de apenas refNumber
    var refNumberCalculationsSorted = topologicalSort(refNumberCalculations, subSectionKPIs);

    refNumberCalculationsSorted.forEach((subSectionKPITarget) => {
        var subSection = getSubSectionFromID(subSectionKPITarget.subSectionID, moduleObject);
        if (subSection != null) {
            var numberOfRows = subSection.isColumnRow ? subSection.numberOfRows : 1;
            for (let rowIndex = 0; rowIndex < numberOfRows; rowIndex++) {
                answers = CalculateTargetSubsectionKPI(subSectionKPITarget, answers, subSectionKPIs, column, rowIndex, version, columnRows, moduleObject, setKPIEvidences, kpiEvidences);
            }
        }

        if (setKPIEvidences && kpiEvidences && subSectionKPIs) {
            const calcRef = String(subSectionKPITarget.refNumber).trim();
            subSectionKPIs
                .filter(ssk =>
                    String(ssk.evidenceRefNumberValidate ?? ssk.EvidenceRefNumberValidate ?? '').trim() === calcRef
                )
                .forEach(ssk => {
                    answers
                        .filter(a => a.subSectionKPIID == ssk.subSectionKPIID)
                        .forEach(ans => {
                            const sskColumn = columnRows.find(x => x.columnRowID == ssk.columnRowID);
                            validateEvidence({
                                subSectionKPIID: ssk.subSectionKPIID,
                                value: ans.numberValue ?? ans.textValue ?? '',
                                column: ans.column,
                                row: ans.row,
                                extraTypeID: getExtraIdType(sskColumn, answers, ssk.refNumber, ans.column, ans.row),
                                kpiEvidences, setKPIEvidences, subSectionKPIs, answers,
                            });
                        });
                });
        }
    });

    return answers;
}

export const CalculateTargetSubsectionKPI = (subSectionKPITarget, answers, subSectionKPIs, column = null, row = null, version, columnRows, moduleObject, setKPIEvidences, kpiEvidences = null) => {
    var valueCalculated = null;
    var valueDisplay = null;
    var valueCalculatedFormatted = null;
    var subSectionKPIColumn = columnRows.find(x => x.columnRowID == subSectionKPITarget.columnRowID);

    var columnIndex = subSectionKPIColumn?.minimumQuantity > 1 ? column : null;
    var rowIndex = getSubSectionFromID(subSectionKPITarget.subSectionID, moduleObject)?.isColumnRow ? row != null ? row : 0 : null;
    var extraIdType = getExtraIdType(subSectionKPIColumn, answers, subSectionKPITarget.refNumber, columnIndex, rowIndex);

    var answersWithoutTargetRefNumber = getNotChangedAnswers(answers, subSectionKPITarget, subSectionKPITarget.refNumber, columnIndex, rowIndex);

    if (subSectionKPITarget.inputCalc == "DisplayText" && subSectionKPITarget.listTreeAttrSourceRefNumber && subSectionKPITarget.listTreeAttrName) {
        const listTreeRes = resolveListTreeAttrCalculationResult(
            subSectionKPITarget,
            answers,
            columnIndex,
            rowIndex,
            moduleObject,
            subSectionKPIs,
        );
        valueCalculated = listTreeRes.numberValue;
        valueDisplay = listTreeRes.textValue;

        var unitMeasureLt = GetTypeInput(
            subSectionKPITarget.unitMeasureID,
            subSectionKPITarget.unitMeasure.type,
        );
        if (unitMeasureLt && Number.isInteger(unitMeasureLt.decimalPrecision) && valueCalculated != null && valueCalculated !== '') {
            valueCalculatedFormatted = Number(valueCalculated).toFixed(unitMeasureLt.decimalPrecision);
        }
    }
    else if (subSectionKPITarget.inputCalc == "Calculation") {
        valueCalculated = calculation(subSectionKPITarget.refNumber, subSectionKPITarget.calculation, answers, version, columnIndex, rowIndex, moduleObject);

        var unitMeasure = GetTypeInput(
            subSectionKPITarget.unitMeasureID,
            subSectionKPITarget.unitMeasure.type,
        );
        if (unitMeasure && Number.isInteger(unitMeasure.decimalPrecision) && valueCalculated) {
            valueCalculatedFormatted = valueCalculated.toFixed(unitMeasure.decimalPrecision)
        }
    }
    else if (subSectionKPITarget.inputCalc == "DisplayText") {
        valueDisplay = getTextValueFromCalculationParse(subSectionKPITarget.calculation, answers, columnIndex, rowIndex, subSectionKPIColumn)[0] ?? "null";
    }

    validateEvidence({
        subSectionKPIID: subSectionKPITarget.subSectionKPIID,
        value: valueCalculatedFormatted ?? valueCalculated ?? '',
        column: columnIndex,
        row: rowIndex,
        extraTypeID: extraIdType,
        kpiEvidences, setKPIEvidences,
        subSectionKPIs,
        answers,
    });

    if (valueCalculated != null || valueDisplay != null) {
        var oldAnswer = getAnswers(
            {
                'newAnswers': answers,
                'ref': subSectionKPITarget.refNumber,
                'subSectionKPI': subSectionKPITarget,
                'row': rowIndex,
                'column': columnIndex
            })[0];

        var targetAnswer = {
            "subSectionKPIID": subSectionKPITarget.subSectionKPIID,
            "refNumber": subSectionKPITarget.refNumber,
            "numberValue": valueCalculated,
            "subSectionID": subSectionKPITarget.subSectionID,
            "textValue": valueDisplay,
            "comment": oldAnswer != null ? oldAnswer.comment : null,
            "row": rowIndex,
            "column": columnIndex,
            "file": oldAnswer != null ? oldAnswer.file : null
        }
        if (extraIdType != null) {
            targetAnswer[extraIdType.type] = extraIdType.value * 1;
        }

        var answerToBeValited = answersToBeValited.find(x => x.subSectionKPIID == targetAnswer.subSectionKPIID
            && x.column == targetAnswer.column
            && x.row == targetAnswer.row);

        if (answerToBeValited == null) {
            answersToBeValited.push({ 'subSectionKPI': subSectionKPITarget, ...targetAnswer });
        }

        answers = [...answersWithoutTargetRefNumber, targetAnswer];
        LinkedTolerancesToValidate(subSectionKPITarget, answers, subSectionKPIs, columnIndex, rowIndex);
        answers = [...refNumberCalculationsDependencies(subSectionKPITarget, answers, subSectionKPIs, columnIndex, row, version, columnRows, moduleObject, setKPIEvidences, kpiEvidences)];
    } else {
        answers = [...answersWithoutTargetRefNumber];
        answers = [...refNumberCalculationsDependencies(subSectionKPITarget, answers, subSectionKPIs, columnIndex, row, version, columnRows, moduleObject, setKPIEvidences, kpiEvidences)];
    }

    return answers;
}

export const getAnswers = ({ newAnswers, ref, subSectionKPI, row, column }) => {
    var myAnswer;
    var filter = {
        'subSectionKPIID': subSectionKPI?.subSectionKPIID,
        'refNumber': ref,
        'column': column,
        'row': row,
    }

    myAnswer = newAnswers.filter(function (item) {
        for (var key in filter) {
            if (filter[key] == null)
                continue;
            else if (item[key] == null || item[key] != filter[key])
                return false;
        }
        return true;
    });

    return myAnswer;
};

/**
 * Respostas do KPI referência para "Selection from kpi".
 * Com várias linhas na subseção, o KPI fonte costuma ter row null; filtrar por row=N exclui essas respostas e esvazia as opções.
 */
export function getRefAnswersForSelectionFromKpi(
    moduleObject,
    selectAnswersRefNumber,
    refSubSectionKPI,
    { numberOfRows = 1, numberOfColumns = 1, row = null, column = null } = {},
) {
    if (!refSubSectionKPI || selectAnswersRefNumber == null) return [];
    const col = numberOfColumns > 1 ? column : null;
    const tryRow = numberOfRows > 1 ? row : null;

    const tryFetch = (r, c) =>
        getAnswers({
            newAnswers: moduleObject.answers,
            ref: selectAnswersRefNumber,
            subSectionKPI: refSubSectionKPI,
            row: r,
            column: c,
        }) || [];

    let refAnswers = tryFetch(tryRow, col);
    if (refAnswers.length === 0 && numberOfRows > 1) refAnswers = tryFetch(null, col);
    if (refAnswers.length === 0 && numberOfColumns > 1) refAnswers = tryFetch(tryRow, null);
    if (refAnswers.length === 0 && (numberOfRows > 1 || numberOfColumns > 1))
        refAnswers = tryFetch(null, null);
    return refAnswers;
}

/**
 * "Selection from kpi" cujo KPI referência é ListTreeSelect com listTreeID — labels longos (path completo).
 */
export function isWideListTreeSelectionFromKpi(sskpi, subSectionKPIs) {
    if (sskpi?.unitMeasure?.type !== 'Selection from kpi' || !sskpi.selectAnswersRefNumber) {
        return false;
    }
    if (sskpi.listTreeID) return true;
    const refS = subSectionKPIs?.find(x => x.refNumber === sskpi.selectAnswersRefNumber);
    if (!refS) return false;
    if (refS.unitMeasure?.description !== 'ListTreeSelect') return false;
    return !!(refS.listTreeID ?? sskpi.listTreeID);
}

/**
 * Colunas que devem ocupar mais largura no modo linha (selects / listas longas).
 * Exclui fuelTypeUnit (unidade curta) e campos numéricos.
 */
export function isWideRowModeValueColumn(sskpi, subSectionKPIs) {
    if (!sskpi?.unitMeasure) return false;
    if (isWideListTreeSelectionFromKpi(sskpi, subSectionKPIs)) return true;
    if (sskpi.listTreeID && sskpi.optionsModeView > 0) return true;
    if (sskpi.unitMeasure.type === 'Selection from kpi' && sskpi.selectAnswersRefNumber) {
        return true;
    }
    const t = sskpi.unitMeasure.type;
    if (
        t === 'selectfuel' ||
        t === 'selectculture' ||
        t === 'selectCuringBarn' ||
        t === 'selectcountry'
    ) {
        return true;
    }
    const it = sskpi.unitMeasure.inputType;
    if (it == null || it === '') return false;
    const its = String(it);
    if (its === 'multiselectcustom') return true;
    if (its.startsWith('select')) return true;
    return false;
}

/**
 * Larguras de colunas no modo linha: colunas "largas" (selects, list tree, etc.) vs estreitas (números, texto curto).
 */
export function computeRowModeValueColumnWidths(
    kpi,
    subSectionKPIs,
    columnRows,
    reordenateColumns,
    valueColumnsWidth,
    widePercent = 70,
) {
    const orderedCols = reordenateColumns(columnRows).filter(x => !x.isParentColumn);
    let wideCount = 0;
    let narrowCount = 0;
    for (const cr of orderedCols) {
        const s = kpi?.subSectionKPIs?.find(x => x.columnRowID == cr.columnRowID);
        if (!s) continue;
        if (isWideRowModeValueColumn(s, subSectionKPIs)) wideCount++;
        else narrowCount++;
    }
    if (wideCount === 0) {
        return {
            hasWide: false,
            uniformPercent: valueColumnsWidth,
            widePercent,
            narrowPercent: null,
        };
    }
    if (narrowCount === 0) {
        const eq = Math.round((100 / wideCount) * 100) / 100;
        return {
            hasWide: true,
            uniformPercent: valueColumnsWidth,
            widePercent: eq,
            narrowPercent: null,
        };
    }
    const narrowTotalBudget = Math.min(44, 7 * narrowCount + 6);
    const usedNarrow = narrowTotalBudget;
    let perWide = (100 - usedNarrow) / wideCount;
    perWide = Math.max(12, Math.min(48, perWide));
    const actualNarrowTotal = 100 - perWide * wideCount;
    const narrowEach = Math.max(4, actualNarrowTotal / narrowCount);
    return {
        hasWide: true,
        uniformPercent: valueColumnsWidth,
        widePercent: Math.round(perWide * 100) / 100,
        narrowPercent: Math.round(narrowEach * 100) / 100,
    };
}

export function getRowModeValueTdWidthStyle(sskpi, subSectionKPIs, layout) {
    if (!layout?.hasWide) {
        return layout?.uniformPercent != null ? `${layout.uniformPercent}%` : 'auto';
    }
    if (!sskpi) {
        const fallback =
            layout.narrowPercent != null ? layout.narrowPercent : layout.widePercent;
        return `${fallback != null ? fallback : layout.uniformPercent}%`;
    }
    return isWideRowModeValueColumn(sskpi, subSectionKPIs)
        ? `${layout.widePercent}%`
        : `${layout.narrowPercent}%`;
}

/**
 * Extrai o refNumber do argumento de FILTERLISTTREE([ref]) no campo Calculation.
 * Ex.: FILTERLISTTREE([00006]), FILTERLISTTREE(00006)
 */
export const parseFilterListTreeRefNumber = calculation => {
    if (calculation == null || calculation === '') return null;
    const m = String(calculation).match(/FILTERLISTTREE\s*\(\s*\[?\s*([^\]\s)]+)\s*\]?\s*\)/i);
    return m ? String(m[1]).trim() : null;
};

/**
 * IDs gravados pelo ListTreeSelect (FormInput listtreeselect): um ID ou JSON array de IDs.
 */
export const parseListTreeItemIdsFromTextValue = (textValue) => {
    if (textValue == null || String(textValue).trim() === '') return [];
    const s = String(textValue).trim();
    if (s.startsWith('[')) {
        try {
            const arr = JSON.parse(s);
            if (!Array.isArray(arr)) return [];
            const ids = arr.map(x => Number(x)).filter(n => !Number.isNaN(n));
            return [...new Set(ids)];
        } catch {
            return [];
        }
    }
    const n = Number(s);
    return Number.isNaN(n) ? [] : [n];
};

/**
 * Compara refNumbers vindos do admin/API (ex.: "00006", 6, "6").
 */
export function refNumbersLooseEqual(a, b) {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    const sa = String(a).trim();
    const sb = String(b).trim();
    if (sa === sb) return true;
    const na = Number(sa);
    const nb = Number(sb);
    if (!Number.isNaN(na) && !Number.isNaN(nb) && na === nb) return true;
    return false;
}

/**
 * Lê ListTreeItemAttr do objeto retornado por getItems (chave exata ou ignorando maiúsculas/minúsculas).
 */
export function getListTreeAttrValueFromAttrsObject(attrsObj, attrName) {
    if (!attrsObj || attrName == null || String(attrName).trim() === '') return undefined;
    const name = String(attrName).trim();
    if (Object.prototype.hasOwnProperty.call(attrsObj, name)) return attrsObj[name];
    const lower = name.toLowerCase();
    const key = Object.keys(attrsObj).find(k => String(k).toLowerCase() === lower);
    return key !== undefined ? attrsObj[key] : undefined;
}

/**
 * Mapa listTreeItemID -> attrs: cobre chave number/string no Map.
 */
export function getAttrsForListTreeItemId(attrsByItemId, listTreeItemID) {
    if (!attrsByItemId || listTreeItemID == null) return undefined;
    if (attrsByItemId.has(listTreeItemID)) return attrsByItemId.get(listTreeItemID);
    const n = Number(listTreeItemID);
    if (!Number.isNaN(n) && attrsByItemId.has(n)) return attrsByItemId.get(n);
    const s = String(listTreeItemID);
    if (attrsByItemId.has(s)) return attrsByItemId.get(s);
    return undefined;
}

/**
 * Valor do ListTreeItemAttr para KPI com Calculation + listTreeAttrSourceRefNumber + listTreeAttrName.
 */
export function resolveListTreeAttrCalculationResult(targetSsk, answers, column, row, moduleObject, subSectionKPIs) {
    const sourceRef = targetSsk.listTreeAttrSourceRefNumber;
    const attrName = targetSsk.listTreeAttrName;
    if (!sourceRef || !attrName) return { numberValue: null, textValue: null };
    const sourceSsk = subSectionKPIs.find(x => refNumbersLooseEqual(x.refNumber, sourceRef));
    if (!sourceSsk) return { numberValue: null, textValue: null };
    const sourceAnswers = getAnswers({
        newAnswers: answers,
        ref: sourceSsk.refNumber,
        subSectionKPI: sourceSsk,
        row,
        column,
    });
    const answer = sourceAnswers[0];
    if (!answer) return { numberValue: null, textValue: null };
    const listTreeItemID = answer.listTreeItemID ?? parseListTreeItemIdsFromTextValue(answer.textValue)[0];
    if (listTreeItemID == null) return { numberValue: null, textValue: null };
    const cache = moduleObject?.listTreeItemAttrsCache || {};
    const attrsObj =
        cache[listTreeItemID] ??
        cache[String(listTreeItemID)] ??
        cache[Number(listTreeItemID)];
    const rawAttr = getListTreeAttrValueFromAttrsObject(attrsObj || {}, attrName);
    const parsed = parseAttrValueForTargetSubSectionKpi(
        targetSsk,
        rawAttr !== undefined && rawAttr !== null ? rawAttr : '',
    );
    return {
        numberValue: parsed.value != null ? parsed.value : null,
        textValue:
            parsed.text !== '' && parsed.text != null ? parsed.text : null,
    };
}

/**
 * Converte valor de ListTreeItemAttr para numberValue/textValue conforme o tipo do KPI alvo.
 */
export function parseAttrValueForTargetSubSectionKpi(targetSsk, rawAttr) {
    if (rawAttr == null || String(rawAttr).trim() === '') return { text: '', value: null };
    const s = String(rawAttr).trim();
    const t = (targetSsk?.unitMeasure?.type || '').toLowerCase();
    if (t === 'number' || t === 'currency' || t === 'numberinput' || t === 'percent') {
        const n = parseFloat(s.replace(/\s/g, '').replace(',', '.'));
        if (!Number.isNaN(n)) return { text: '', value: n };
    }
    return { text: s, value: null };
}

/**
 * Rótulo com caminho completo até o nó (ex.: "Curing Fuels > Conventional Barn > Own Wood"),
 * usando parentID + value da lista plana de ListTree/getItems.
 */
export function buildListTreeItemPathLabel(flatItems, listTreeItemID, separator = ' > ') {
    if (!flatItems?.length || listTreeItemID == null || listTreeItemID === '') return '';
    const byId = new Map();
    flatItems.forEach(i => {
        const id = i.listTreeItemID;
        if (id != null && id !== '') {
            const n = Number(id);
            if (!Number.isNaN(n)) byId.set(n, i);
        }
    });
    const startId = Number(listTreeItemID);
    if (Number.isNaN(startId)) return String(listTreeItemID);
    const segments = [];
    let cur = byId.get(startId);
    const guard = new Set();
    while (cur != null) {
        const cid = cur.listTreeItemID;
        if (cid == null || guard.has(cid)) break;
        guard.add(cid);
        const v = cur.value != null ? String(cur.value).trim() : '';
        if (v) segments.unshift(v);
        const p = cur.parentID;
        if (p == null || p === '') break;
        cur = byId.get(Number(p));
    }
    if (segments.length > 0) return segments.join(separator);
    const leaf = byId.get(startId);
    return leaf?.value != null ? String(leaf.value).trim() : String(listTreeItemID);
}

/**
 * Mesma API que FormInput usa para listtreeselect com valor persistido: ListTree/getItems.
 * Monta opções de select { value, text } para os listTreeItemIDs informados (ordem preservada).
 * text = caminho completo (pais até a folha) para leitura no select (ex. Selection from kpi + ListTree).
 * Inclui mapa listTreeItemID -> attrs (Name -> Value) para propagar ListTreeItemAttr.
 *
 * Uma única chamada ListTree/getItems por listTreeID (cache + dedupe em voo) — várias linhas/células não disparam N requests.
 */
const listTreeGetItemsInflight = new Map();
const listTreeGetItemsFlatCache = new Map();

export async function fetchListTreeFlatByListTreeID(listTreeID) {
    if (!listTreeID) return [];
    const cached = listTreeGetItemsFlatCache.get(listTreeID);
    if (cached) return cached;
    let p = listTreeGetItemsInflight.get(listTreeID);
    if (!p) {
        p = Api.get(`ListTree/getItems?listTreeID=${listTreeID}`)
            .then(res => {
                const flat = res?.data?.response ?? [];
                listTreeGetItemsFlatCache.set(listTreeID, flat);
                listTreeGetItemsInflight.delete(listTreeID);
                return flat;
            })
            .catch(err => {
                listTreeGetItemsInflight.delete(listTreeID);
                throw err;
            });
        listTreeGetItemsInflight.set(listTreeID, p);
    }
    return p;
}

/**
 * Opções de select para filhos diretos dos listTreeItemIDs informados (mesma ListTree).
 * Preserva ordem de aparição na lista plana da API.
 * usePathLabel=true => "Pai > Filho"; false => somente "Filho".
 */
export const fetchListTreeSelectOptionsForDirectChildrenOfParents = async (
    listTreeID,
    parentItemIds,
    { usePathLabel = true } = {},
) => {
    if (!listTreeID || !parentItemIds?.length)
        return { options: [], attrsByItemId: new Map() };
    const flat = await fetchListTreeFlatByListTreeID(listTreeID);
    const parentSet = new Set(parentItemIds.map(id => Number(id)).filter(n => !Number.isNaN(n)));
    const attrsByItemId = new Map();
    flat.forEach(i => {
        const raw = i.attrs ?? i.Attrs;
        const a = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
        const id = i.listTreeItemID;
        attrsByItemId.set(id, a);
        const n = Number(id);
        if (!Number.isNaN(n)) attrsByItemId.set(n, a);
        attrsByItemId.set(String(id), a);
    });
    const seenChild = new Set();
    const childIds = [];
    flat.forEach(i => {
        if (i.parentID == null) return;
        const pid = Number(i.parentID);
        if (!parentSet.has(pid)) return;
        const cid = Number(i.listTreeItemID);
        if (Number.isNaN(cid) || seenChild.has(cid)) return;
        seenChild.add(cid);
        childIds.push(i.listTreeItemID);
    });
    const itemById = new Map();
    flat.forEach(i => {
        const id = Number(i.listTreeItemID);
        if (!Number.isNaN(id)) itemById.set(id, i);
    });
    return {
        options: childIds.map(id => {
            const n = Number(id);
            const pathText = buildListTreeItemPathLabel(flat, Number.isNaN(n) ? id : n);
            const leafTextRaw =
                !Number.isNaN(n) && itemById.has(n)
                    ? itemById.get(n)?.value
                    : null;
            const leafText =
                leafTextRaw != null && String(leafTextRaw).trim() !== ''
                    ? String(leafTextRaw).trim()
                    : '';
            return {
                value: String(id),
                text: (usePathLabel ? pathText : leafText) || pathText || String(id),
            };
        }),
        attrsByItemId,
    };
};

export const fetchListTreeSelectOptionsByItemIds = async (listTreeID, orderedItemIds) => {
    if (!listTreeID || !orderedItemIds?.length)
        return { options: [], attrsByItemId: new Map() };
    const flat = await fetchListTreeFlatByListTreeID(listTreeID);
    const attrsByItemId = new Map();
    flat.forEach(i => {
        const raw = i.attrs ?? i.Attrs;
        const a = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
        const id = i.listTreeItemID;
        attrsByItemId.set(id, a);
        const n = Number(id);
        if (!Number.isNaN(n)) attrsByItemId.set(n, a);
        attrsByItemId.set(String(id), a);
    });
    return {
        options: orderedItemIds.map(id => {
            const n = Number(id);
            const pathText = buildListTreeItemPathLabel(flat, Number.isNaN(n) ? id : n);
            return {
                value: String(id),
                text: pathText || String(id),
            };
        }),
        attrsByItemId,
    };
};

export function getLiveEvidenceRefValidateValue({
    moduleObject,
    subSectionKPIs,
    evidenceSubSectionKPI,
    row,
    numberOfRows,
    columnRows,
    reordenateColumns,
    evidenceColumn = undefined,
    evidenceCultureTypeID = undefined,
  }) {
    if (!moduleObject?.answers?.length || !evidenceSubSectionKPI) {
      return null;
    }
    const raw =
      evidenceSubSectionKPI.evidenceRefNumberValidate ??
      evidenceSubSectionKPI.EvidenceRefNumberValidate;
    if (raw == null || String(raw).trim() === '') {
      return null;
    }
    const refTrim = String(raw).trim();
  
    const sid = evidenceSubSectionKPI.subSectionID;
    const nonParentForPick =
      columnRows && reordenateColumns
        ? reordenateColumns(columnRows).filter(x => x.isParentColumn === false)
        : [];
  
    const refMatchesWithSid =
      subSectionKPIs?.length > 0
        ? subSectionKPIs.filter(
            x =>
              String(x.refNumber).trim() === refTrim &&
              (sid == null || x.subSectionID == sid),
          )
        : [];
    const refMatchesAny =
      subSectionKPIs?.length > 0
        ? subSectionKPIs.filter(x => String(x.refNumber).trim() === refTrim)
        : [];
    const refPool =
      refMatchesWithSid.length > 0 ? refMatchesWithSid : refMatchesAny;
  
    let validateSSK = null;
    if (refPool.length === 1) {
      validateSSK = refPool[0];
    } else if (refPool.length > 1) {
      const colIdxPick =
        evidenceColumn != null &&
        evidenceColumn !== '' &&
        !Number.isNaN(Number(evidenceColumn))
          ? Number(evidenceColumn)
          : -1;
      if (colIdxPick >= 0 && colIdxPick < nonParentForPick.length) {
        const targetCrId = nonParentForPick[colIdxPick].columnRowID;
        validateSSK =
          refPool.find(x => x.columnRowID === targetCrId) ?? refPool[0];
      } else {
        validateSSK = refPool[0];
      }
    }
  
    let matches = [];
  
    if (validateSSK) {
      matches = moduleObject.answers.filter(
        x =>
          x.subSectionKPIID == validateSSK.subSectionKPIID &&
          String(x.refNumber).trim() === refTrim,
      );
  
      if (numberOfRows != null && numberOfRows > 1 && row != null && row !== '') {
        const rowN = Number(row);
        const rowFiltered = matches.filter(
          x => x.row === row || x.row === rowN || Number(x.row) === rowN,
        );
        if (rowFiltered.length > 0) {
          matches = rowFiltered;
        }
      }
  
      if (columnRows && reordenateColumns && matches.length > 0) {
        const nonParent = reordenateColumns(columnRows).filter(
          x => x.isParentColumn === false,
        );
        const answersUseColumn = matches.some(
          m => m.column != null && m.column !== '',
        );
        if (nonParent.length > 1 && answersUseColumn) {
          const colIdxFromEvidence =
            evidenceColumn != null &&
            evidenceColumn !== '' &&
            !Number.isNaN(Number(evidenceColumn))
              ? Number(evidenceColumn)
              : null;
          if (colIdxFromEvidence != null && colIdxFromEvidence >= 0) {
            const colFiltered = matches.filter(
              x =>
                x.column === colIdxFromEvidence ||
                Number(x.column) === colIdxFromEvidence,
            );
            if (colFiltered.length > 0) {
              matches = colFiltered;
            }
          } else {
            const colIdx = nonParent.findIndex(
              cr => cr.columnRowID === validateSSK.columnRowID,
            );
            if (colIdx >= 0) {
              const colFiltered = matches.filter(x => x.column === colIdx);
              if (colFiltered.length > 0) {
                matches = colFiltered;
              }
            }
          }
        }
      }

      // Cross-module fallback: validateSSK found in current module's subSectionKPIs but
      // the actual answer belongs to another module (different subSectionKPIID in answers).
      if (matches.length === 0) {
        matches = moduleObject.answers.filter(
          x => String(x.refNumber).trim() === refTrim,
        );
        if (evidenceCultureTypeID != null && evidenceCultureTypeID !== '' && evidenceCultureTypeID !== undefined) {
          const cFiltered = matches.filter(x => x.cultureTypeID == evidenceCultureTypeID);
          if (cFiltered.length > 0) matches = cFiltered;
        }
      }
    } else {
      // Validate ref is in another module: row/column on this form are for the evidence KPI's grid, not the
      // validate module's layout — match by ref (and culture when it narrows results only).
      matches = moduleObject.answers.filter(
        x => String(x.refNumber).trim() === refTrim,
      );
  
      if (
        evidenceCultureTypeID != null &&
        evidenceCultureTypeID !== '' &&
        evidenceCultureTypeID !== undefined
      ) {
        const cFiltered = matches.filter(
          x => x.cultureTypeID == evidenceCultureTypeID,
        );
        if (cFiltered.length > 0) {
          matches = cFiltered;
        }
      }
    }
  
    const ans = matches[0];
    if (!ans) {
      return null;
    }
    let n = null;
    if (ans.numberValue != null && ans.numberValue !== '') {
      const num = Number(ans.numberValue);
      if (!Number.isNaN(num)) {
        n = num;
      }
    }
    if (n == null && ans.textValue != null && String(ans.textValue).trim() !== '') {
      const fromText = parseFloat(
        String(ans.textValue).replace(/,/g, '').replace(/\s/g, ''),
      );
      if (!Number.isNaN(fromText)) {
        n = fromText;
      }
    }
    return n;
  }

const getKPIsFromSubsection = (subSection, subSectionKPI) => {
    var subSectionKPIs = [];

    if (subSection != null) {
        subSectionKPIs = subSection.subSectionKPI.map((subSectionKPI) => {
            return subSectionKPI;
        });
    } else {
        subSectionKPIs.push(subSectionKPI);
    }

    return subSectionKPIs;
};

const getNotChangedAnswers = (answers, subSectionKPI, ref, column, row) => {
    var notChangedAnswers = [];

    if (column != null) { //Sub Section - Production and farmer data, Extension services
        notChangedAnswers = answers.filter(x => (x.subSectionKPIID != subSectionKPI.subSectionKPIID)
            || (x.subSectionKPIID == subSectionKPI.subSectionKPIID && x.column != column));
    } else if (row != undefined && column != undefined) { // Sub section - Central Gegraphic coordinates of the culture growing States or Province
        notChangedAnswers = answers.filter(x => (x.subSectionKPIID != subSectionKPI.subSectionKPIID)
            || (x.subSectionKPIID == subSectionKPI.subSectionKPIID && x.row != row));
    } else if (row != null) {
        notChangedAnswers = answers.filter(x => (x.subSectionKPIID != subSectionKPI.subSectionKPIID)
            || (x.subSectionKPIID == subSectionKPI.subSectionKPIID && x.row != row));
    } else {
        notChangedAnswers = answers.filter(x => x.subSectionKPIID != subSectionKPI.subSectionKPIID);
    }

    return notChangedAnswers;
};

export async function FindReadConsentLastCropYear(moduleID, companyID, ReportYearID, cultureTypeID = null, status, thriveVersionID, userRoles) {
    var readConsentResult = false;

    if (userRoles.includes("RoleApprover") && companyID) {
        if (status == 2) {
            await Api.get(`ReadConsent/FindReadConsentLastCropYear?moduleID=${moduleID}&companyID=${companyID}&ReportYearID=${ReportYearID}&versionID=${thriveVersionID}`).then((result) => {
                if (result && result.data.response) {
                    readConsentResult = result.data.response;
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        }
        else {
            readConsentResult = true;
        }
    }

    return readConsentResult;
}

export async function CheckEditKPIsToReopenModules(requestKPI, companyID, ReportYearID, moduleID, cultureTypeID = null, isSendEvent, loadData, setLoading, loading, answers) {
    try {
        var request = {
            answers: requestKPI,
            moduleID: moduleID,
            ReportYearID: ReportYearID,
            selectedCompanyID: companyID,
            cultureTypeID: cultureTypeID
        };

        Api.post(`ThriveValue/CheckEditKPIsToReopenModules`, request).then(async (result) => {
            if (result && result.data) {
                // console.log(result.data.response)
                if (result.data.response.descriptionConcat != "") {
                    Swal.fire({
                        title: 'Some modules need to be reopened if the changes are confirmed',
                        text: `If you press Yes, ${result.data.response.descriptionConcat} will be reopened and will need to be approved again. Are you sure?`,
                        icon: 'warning',
                        showDenyButton: true,
                        confirmButtonColor: '#112A61',
                        denyButtonColor: '#B0B0BB',
                        denyButtonText: 'No',
                        confirmButtonText: 'Yes',
                        allowOutsideClick: false,
                        showCloseButton: true
                    }).then(async (rlt) => {
                        if (rlt.isConfirmed) {
                            await Api.post("ThriveValue/saveAsDraft", answers)
                                .then(async (response) => {
                                    if (isSendEvent) {
                                        await Api.post(`ThriveValue/send?moduleID=${moduleID}&ReportYearID=${ReportYearID}${cultureTypeID != null ? `&cultureTypeID=${cultureTypeID}` : ""}`).then((results) => {
                                            success_message("The data was sent successfully!");

                                            loadData();
                                        }).catch((error) => {
                                            exceptionNotificationAPI(error);
                                            setLoading(false);
                                        });
                                    }
                                    else {
                                        success_message("The data was saved successfully!");
                                        loadData();
                                    }
                                }).then(async () => {
                                    var requestToSend = {
                                        ObjToRequest: result.data.response.moduleIDsList,
                                        companyID: companyID,
                                        ReportYearID: ReportYearID,
                                        cultureTypeID: cultureTypeID
                                    }

                                    await Api.post(`ThriveValue/FlowReopenModules`, requestToSend).then((results) => {
                                        success_message("The modules was reopened successfully!");

                                        loadData();
                                    }).catch((error) => {
                                        exceptionNotificationAPI(error);
                                        setLoading(false);
                                    });
                                })
                        } else {
                            setLoading(false);
                        }
                    });
                }
                else {
                    await Api.post("ThriveValue/saveAsDraft", answers)
                        .then(async (response) => {
                            if (isSendEvent) {
                                await Api.post(`ThriveValue/send?moduleID=${moduleID}&ReportYearID=${ReportYearID}${cultureTypeID != null ? `&cultureTypeID=${cultureTypeID}` : ""}`).then((results) => {
                                    success_message("The data was sent successfully!");
                                    loadData();
                                }).catch((error) => {
                                    exceptionNotificationAPI(error);
                                    setLoading(false);
                                });
                            }
                            else {
                                success_message("The data was saved successfully!");
                                loadData();
                            }
                        })
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }
    catch (error) {
        exceptionNotificationAPI(error);
    }
}

export async function CheckLastVersionChangesByModules(request, cultureTypeID = null, isSendEvent, loadData, setLoading, loading) {
    try {
        Api.post(`ThriveValue/CheckLastVersionChangesByModules`, request).then((result) => {
            if (result && result.data) {
                CheckEditKPIsToReopenModules(result.data.response, request.selectedCompanyID, request.reportYearID, request.moduleID, cultureTypeID, isSendEvent, loadData, setLoading, loading, request)
            }

        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }
    catch (error) {
        exceptionNotificationAPI(error);
    }
}

export function RoundFixedNumber(num, digits, base = 10) {
    if (num > 0) {
        var pow = Math.pow(base || 10, digits);
        return Math.round(num * pow) / pow;
    }
    else return num;
}

function parseGlidepath(inputString) {
    // Adjusted regex to match the updated string format
    const regex = /\[([0-9]+)\];([0-9]+)/;
    const match = inputString.match(regex);

    // Check if we have a match
    if (match) {
        // Concatenate the first group of numbers (inside brackets) with the second group (after semicolon) using a dot
        return `[${match[1]}.${match[2]}]`;
    } else {
        // Return an empty string or any other default value if no match is found
        return '';
    }
}

export function calculation(refNumber, advancedCalculation, answers, version, column = null, row = null, moduleObject, roundComparison = false) {
    var result = null;

    if (version && ![0, 1, 3, 5, 6, 8, 9].some(item => version.status === item)) {
        result = getAnswers(
            {
                'newAnswers': answers,
                'ref': refNumber,
                'row': row,
                'column': column
            }
        )[0]?.numberValue;
    } else {
        //improvement for calculations:
        //create keyword object, each keyword has it's own function call to execute
        //get all keywords on calculation
        //execute all keywords
        //new check for keywords while found at least 1 keyword on last check

        var formattedCalculation = advancedCalculation.replaceAll(" ", "");

        if (parseFilterListTreeRefNumber(advancedCalculation)) {
            return null;
        }

        if (formattedCalculation.includes("GLIDEPATH")) {
            // Concatenate the first and second group of numbers with a dot between them
            formattedCalculation = parseGlidepath(formattedCalculation);
            var values = [];
            var ref = formattedCalculation;
            values.push(...getValueFromCalculationParse(ref, answers));
            var sum = values.every(x => x == null) ? "null" : values.reduce((previous, current) => previous + current, 0) + "_";
            formattedCalculation = sum;
        }




        if (formattedCalculation.includes("FROMLASTCROPYEAR")) {
            var count = (formattedCalculation.match(/FROMLASTCROPYEAR/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("FROMLASTCROPYEAR", formattedCalculation);

                if (parsed != null) {
                    var splits = parsed.ExpressionValues.split(';')
                    if (splits.length > 0) {
                        var values = [];
                        splits.map((item) => {
                            var ref = '[' + item.replace('[', '').replace(']', '') + '.5' + ']';
                            values.push(...getValueFromCalculationParse(ref, answers));
                        })


                        var sum = values.every(x => x == null) ? "null" : values.reduce((previous, current) => previous + current, 0) + "_";

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, sum);
                    }
                }
            }
        }

        //ALLTYPES(SUM;[$1] * [$2];[15065];[15049])
        if (formattedCalculation.includes("ALLTYPES")) {
            var count = (formattedCalculation.match(/ALLTYPES/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("ALLTYPES", formattedCalculation);

                if (parsed != null) {
                    var [type, expression, ...splits] = parsed.ExpressionValues.split(';')
                    if (type != null && expression != null && splits != null) {
                        var resultFragment = "";
                        if (type === 'SUM' || type === 'MAX' || type === 'AVG') {
                            resultFragment = `${type}([args])`;
                        }

                        var regExp = new RegExp(`(\\[\\$\\d\\])+`, 'g');
                        var expressionMatches = expression.match(regExp);
                        if (getHighestPlaceholderValue(expressionMatches) != splits.length) {
                            resultFragment = 'null';
                        }
                        var answerValues = [];
                        splits.map((item) => {
                            if (item.includes('[')) {
                                var refNumber = item.replace('[', '').replace(']', '')
                                var refNumberAnswers = getAnswers(
                                    {
                                        'newAnswers': answers,
                                        'ref': refNumber
                                    }
                                );

                                answerValues.push(refNumberAnswers);
                            }
                        });
                        var resultList = [];
                        var expressionToEvaluate = expression;
                        var indexOfLongestArray = answerValues.reduce((p, c, i, a) => a[p].length > c.length ? p : i, 0);
                        answerValues[indexOfLongestArray].map((answer) => {
                            var placeholderIndex = indexOfLongestArray + 1;
                            expressionToEvaluate = expressionToEvaluate.replaceAll('[$' + placeholderIndex + ']', answer.numberValue + "_");

                            for (var i = 0; i < answerValues.length; i++) {
                                if (i != indexOfLongestArray) {
                                    var ans = answerValues[i]?.find(x => answer.cultureTypeID != null ? x.cultureTypeID == answer.cultureTypeID : true
                                        && answer.fuelTypeID != null ? x.fuelTypeID == answer.fuelTypeID : true
                                            && answer.countryID != null ? x.countryID == answer.countryID : true) ?? null;
                                    if (ans != null) {
                                        placeholderIndex = i + 1;
                                        expressionToEvaluate = expressionToEvaluate.replaceAll('[$' + placeholderIndex + ']', ans.numberValue + "_");
                                    }
                                }
                            }

                            resultList.push(evaluate(expressionToEvaluate, answers));
                            expressionToEvaluate = expression;
                        });

                        resultFragment = resultFragment.replace('[args]', resultList.join(';'));

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, resultFragment);
                    }
                }
            }
        }

        if (formattedCalculation.includes("MAX")) {
            var count = (formattedCalculation.match(/MAX/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("MAX", formattedCalculation);

                if (parsed != null) {
                    var splits = parsed.ExpressionValues.split(';')
                    if (splits.length > 0) {
                        var values = [];
                        splits.map((item) => {
                            values.push(...getValueFromCalculationParse(item, answers));
                        })


                        var max = values.every(x => x == null) ? "null" : Math.max(...values) + "_";

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, max);
                    }
                }
            }
        }

        if (formattedCalculation.includes("SUMIF")) {
            var count = (formattedCalculation.match(/SUMIF/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("SUMIF", formattedCalculation);

                if (parsed != null) {
                    var [type, condition, matchType, ...splits] = parsed.ExpressionValues.split(';')
                    if (type != null && condition != null && matchType != null && splits != null) {
                        var values = [];
                        //create objects to build a string to use as filter for answers;
                        var filteredAnswers = getFilteredAnswers(type, condition, matchType, answers, moduleObject); // criar
                        //culture, fcv, equal -> CultureTypeId == getCultureTypeId(fcv)
                        //culture, fcv, notequal -> CultureTypeId != getCultureTypeId(fcv)

                        splits.map((item) => {
                            values.push(...getValueFromCalculationParse(item, filteredAnswers));
                        })

                        var sum = values.every(x => x == null) ? "null" : values.reduce((previous, current) => previous + current, 0) + "_";

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, sum);
                    }
                }
            }
        }

        if (formattedCalculation.includes("SUM")) {
            var count = (formattedCalculation.match(/SUM/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("SUM", formattedCalculation);

                if (parsed != null) {
                    var splits = parsed.ExpressionValues.split(';')
                    if (splits.length > 0) {
                        var values = [];
                        splits.map((item) => {
                            values.push(...getValueFromCalculationParse(item, answers));
                        })
                        // console.log(refNumber)
                        // console.log(parsed)
                        // console.log(values)
                        var sum = values.every(x => x == null) ? "null" : values.reduce((previous, current) => previous + current, 0) + "_";

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, sum);
                    }
                }
            }
        }

        if (formattedCalculation.includes("AVG")) {
            var count = (formattedCalculation.match(/AVG/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("AVG", formattedCalculation);

                if (parsed != null) {
                    var splits = parsed.ExpressionValues.split(';')
                    if (splits.length > 0) {
                        var values = [];
                        splits.map((item) => {
                            values.push(...getValueFromCalculationParse(item, answers));
                        })

                        var sum = values.every(x => x == null) ? "null" : values.reduce((previous, current) => previous + current, 0);
                        var avg = sum == "null" ? "null" : ((sum / values.length) || 0) + "_";

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, avg);
                    }
                }
            }
        }

        //IF([15717] < 0;[15033];0)
        if (formattedCalculation.includes("IF")) {
            var count = (formattedCalculation.match(/IF/g) || []).length;
            for (let index = 0; index < count; index++) {
                var parsed = parseKeyWordsFromCalculation("IF", formattedCalculation);

                if (parsed != null) {
                    var splits = parsed.ExpressionValues.split(';')
                    if (splits.length >= 2) {
                        var value = 0;
                        var condition = splits[0];
                        var valueTrue = splits[1];
                        var valueFalse = splits[2] || 0;

                        if (evaluate(condition, answers)) {
                            value = getValueFromCalculationParse(valueTrue, answers);
                        }
                        else {
                            value = getValueFromCalculationParse(valueFalse, answers);
                        }

                        value = value.every(x => x == null) ? "null" : value[0] + "_";

                        formattedCalculation = formattedCalculation.replace(parsed.ExpressionToReplace, value);
                    }
                }
            }
        }

        result = evaluate(formattedCalculation, answers, column, row, roundComparison);
    }

    return result;
}

function parseKeyWordsFromCalculation(keyWord, calculationFormula) {
    var regExp = new RegExp(keyWord + `\\(([^)]+)\\)`);
    var matches = regExp.exec(calculationFormula);

    if (matches && matches.length > 0)
        return {
            'ExpressionToReplace': matches[0],
            'ExpressionValues': matches[1]
        };
    else
        return null;
}

function getValueFromCalculationParse(item, answers, column = null, row = null, addUnderline = false) {
    var value = [];

    if (item.includes('[')) {
        var refNumber = item.replace('[', '').replace(']', '')
        var refNumberAnswers = getAnswers(
            {
                'newAnswers': answers,
                'ref': refNumber,
                'row': row,
                'column': column
            }
        );

        if (refNumberAnswers != null && refNumberAnswers.length > 0) {
            refNumberAnswers.map((answer) => {
                var answerValue = answer.numberValue;
                if (addUnderline) {
                    answerValue += "_";
                }
                value.push(answerValue);
            });
        }
        else {
            refNumberAnswers = getAnswers(
                {
                    'newAnswers': answers,
                    'ref': refNumber,
                }
            );
            if (refNumberAnswers != null) {
                refNumberAnswers.map((answer) => {
                    if (answer.column == null && answer.row == null) {
                        var answerValue = answer.numberValue;
                        if (addUnderline) {
                            answerValue += "_";
                        }
                        value.push(answerValue);
                    }
                });
            }
            else {
                value.push(null);
            }
        }
    }
    else {
        var itemHadUnderline = false;
        if (item.includes("_")) {
            item = item.replace("_", "");
            itemHadUnderline = true;
        }
        item = 1 * item
        if (addUnderline && itemHadUnderline) {
            item += "_";
        }
        value.push(item);

    }

    return value;
}

function getTextValueFromCalculationParse(item, answers, column = null, row = null, subSectionKPIColumn = null) {
    var value = [];

    if (item.includes('[')) {
        var refNumber = item.replace('[', '').replace(']', '')
        var refNumberAnswers = getAnswers(
            {
                'newAnswers': answers,
                'ref': refNumber,
                'row': row,
                'column': column
            }
        );

        if (refNumberAnswers != null && refNumberAnswers.length > 0) {
            refNumberAnswers.map((answer) => {
                value.push(answer.textValue);
            });
        }
        else {
            refNumberAnswers = getAnswers(
                {
                    'newAnswers': answers,
                    'ref': refNumber,
                }
            );
            if (refNumberAnswers != null) {
                refNumberAnswers.map((answer) => {
                    if (answer.column == null && answer.row == null) {
                        value.push(answer.textValue);
                    }
                });
            }
            else {
                value.push(null);
            }
        }
    }
    else {
        value.push(1 * item);
    }

    return value;
}

export function evaluate(formattedCalculation, answers, column = null, row = null, roundComparison = false) {
    if (formattedCalculation.includes("null")) {
        formattedCalculation = formattedCalculation.replaceAll("null", 0);
        // return null;
    }
    var result = null;
    var regexFilter = /[^-()\[\]\d/*+.<>=>_]/g;
    formattedCalculation = formattedCalculation.replace(regexFilter, '');
    var operations = /(?:==|<=|>=|>|<|\+|-|\*|\/)/g;
    var matches = formattedCalculation.match(operations);
    if (matches != null && matches.length > 0) {
        matches = matches.filter((value, index, array) => array.indexOf(value) === index);
        matches.forEach(match => {
            formattedCalculation = formattedCalculation.replaceAll(match, ` ${match} `)
        });
    }

    var advancedCalculationFragments = formattedCalculation.replaceAll("( ", "").replaceAll(" )", "").replaceAll("(", "").replaceAll(")", "").split(" ");

    var expressionToEvaluate = formattedCalculation;

    advancedCalculationFragments.map((fragment, i) => {
        var answer = null;

        if (!isNaN(parseInt(fragment.replace("[", "").replace("]", "")))) {
            answer = getValueFromCalculationParse(fragment, answers, column, row, true)[0] ?? "null";

            // var answerValue = answer == "null" ? answer : answer + "_";

            expressionToEvaluate = expressionToEvaluate.replaceAll(fragment, answer);
        }
    })


    try {
        if (!expressionToEvaluate.includes("_")) {
            return null;
        }
        else {
            expressionToEvaluate = expressionToEvaluate.replaceAll("_", "").replaceAll("null", "0");
        }
        expressionToEvaluate = removeDivByZero(expressionToEvaluate);
        var roundedComparison = roundComparison ? evaluateRoundedComparison(expressionToEvaluate.replace(regexFilter, '')) : null;
        if (roundedComparison != null) {
            return roundedComparison;
        }
        result = Function("return " + expressionToEvaluate.replace(regexFilter, ''))();
        result = !isFinite(result) ? 0 : result;
    } catch (error) {
        console.log({ "ERROR - Expression": expressionToEvaluate });
    }

    return result;
}

// Avalia "<lado esquerdo> <op> <lado direito>" arredondando cada lado para 6 casas (precisão do banco)
// antes de comparar, para que resíduos de ponto flutuante (ex.: 99.99999999999999 >= 100) não gerem alerta falso.
// Retorna null quando a expressão não tem exatamente uma comparação no nível de topo.
function evaluateRoundedComparison(expr) {
    var comparisons = [];
    var depth = 0;
    for (var i = 0; i < expr.length; i++) {
        var char = expr[i];
        if (char === '(') depth++;
        else if (char === ')') depth--;
        else if (char === '<' || char === '>' || char === '=') {
            var operator = expr.substr(i, 2);
            if (!['==', '<=', '>='].includes(operator)) {
                operator = char;
            }
            if (operator === '=') return null;
            if (depth !== 0) return null;
            comparisons.push({ operator: operator, index: i });
            i += operator.length - 1;
        }
    }

    if (comparisons.length !== 1) return null;

    var { operator, index } = comparisons[0];
    var left = Function("return " + expr.substring(0, index))();
    var right = Function("return " + expr.substring(index + operator.length))();
    if (!isFinite(left) || !isFinite(right)) return null;

    left = Number(left.toFixed(6));
    right = Number(right.toFixed(6));

    switch (operator) {
        case '==': return left === right;
        case '<=': return left <= right;
        case '>=': return left >= right;
        case '<': return left < right;
        case '>': return left > right;
        default: return null;
    }
}

export function removeDivByZero(expr) {
    // Padrão: procurar " ( <qualquer coisa que não tenha parênteses> / <qualquer coisa que não tenha parênteses> ) "
    const regex = /\(\s*([^\(\)]+?)\s*\/\s*([^\(\)]+?)\s*\)/;

    let newExpr = expr;
    let match;

    // Enquanto existir alguma correspondência "( ... / ... )"...
    while ((match = newExpr.match(regex)) !== null) {
        const fullMatch = match[0];       // ex: "(100 / 100)" ou "(0 / 100)" ou "(x/0)" se já estivesse substituído
        const numerador = match[1].trim();   // string antes da '/'
        const denominador = match[2].trim(); // string depois da '/'


        //Solução temporária pois estava desconsiderando o -1 nas operações
        const arithmeticPattern = /(\d+(\.\d+)?\s*[\+\-\*\/%]\s*\d+(\.\d+)?)|([\+\-\*\/%])/;
        arithmeticPattern.test(denominador);
        if (arithmeticPattern.test(denominador)) {
            break;
        }

        // Tentar converter denominador para número.
        const denomValue = parseFloat(denominador);
        if (!isNaN(denomValue)) {
            if (denomValue === 0) {
                // Divisão por zero → substituir "fullMatch" inteiro por "0"
                newExpr = newExpr.replace(fullMatch, '0');
            } else {
                // Divisor != 0 → tentar avaliar numerador também como número puro
                const numValue = parseFloat(numerador);
                if (!isNaN(numValue)) {
                    // Ambos num e denom são numéricos → pré-avaliar e substituir
                    const resultado = numValue / denomValue;
                    newExpr = newExpr.replace(fullMatch, resultado.toString());
                } else {
                    // Numerador não é número puro (pode ser expressão mais complexa):
                    // não removemos, apenas saímos do loop para evitar loop infinito.
                    break;
                }
            }
        } else {
            // Denominador não é um número puro (pode conter outras operações/variáveis):
            // também encerramos aqui para não entrar em loop infinito.
            break;
        }
    }

    return newExpr;
}


export function GetCurrentRowCount(subSectionID, subSectionKPIList, answers, columnRowsList) {
    var rowCount = 0;
    var rowAnswers = answers.filter(x => x.row != null);


    var sskList = subSectionKPIList.filter(x => x.subSectionID == subSectionID);


    sskList.map((ssk) => {
        var columnRow = columnRowsList.filter(e => e.columnRowID == ssk.columnRowID)[0]

        if (ssk.calculation != null && (ssk.inputCalc == 'Calculation' || ssk.inputCalc == 'DisplayText') && (columnRow != null && (columnRow.kpiReference != "" && columnRow.kpiReference))) {
            var splitRefNumbers

            var regexFilter = /[^-()\[\]\d/*+.<>=>_]/g;
            var formattedCalculation = ssk.calculation.replace(regexFilter, '');
            var operations = /(?:==|<=|>=|>|<|\+|-|\*|\/)/g;
            var matches = formattedCalculation.match(operations);
            if (matches != null && matches.length > 0) {
                matches = matches.filter((value, index, array) => array.indexOf(value) === index);
                matches.forEach(match => {
                    formattedCalculation = formattedCalculation.replaceAll(match, ` ${match} `)
                });
            }

            splitRefNumbers = formattedCalculation.replaceAll("( ", "").replaceAll(" )", "").replaceAll("(", "").replaceAll(")", "").split(" ");

            splitRefNumbers.map((fragment, i) => {
                if (!isNaN(parseInt(fragment.replace("[", "").replace("]", "")))) {
                    var answerList = getAnswers(
                        {
                            'newAnswers': rowAnswers,
                            'ref': fragment.replace("[", "").replace("]", "")
                        });

                    if (answerList.length > 0) {
                        answerList.map((answ) => {
                            if (answ.row > rowCount) {
                                rowCount = answ.row;
                            }
                        });
                    }
                }
            })
        }

        var answer = getAnswers(
            {
                'newAnswers': rowAnswers,
                'ref': ssk.refNumber
            });

        if (answer.length > 0) {
            answer.map((answ) => {
                if (answ.row > rowCount) {
                    rowCount = answ.row;
                }
            });
        }
    })


    return rowCount + 1;
}

function getSubSectionFromID(subSectionID, moduleObject) {
    var subSection = null;
    moduleObject.data.sections.map((x) => {
        if (subSection == null) {
            if (x.subSections.some(ss => ss.subSectionID == subSectionID)) {
                subSection = x.subSections.find(ss => ss.subSectionID == subSectionID);
                return;
            }
        }
    });

    if (subSection != null) {
        return subSection;
    }

    return false;
}

export function getExtraIdType(columnRow, answers, refnumber, column = null, row = null, textValue = null) {
    if (columnRow?.kpiReference != null) {
        var value = { 'value': null, 'type': null };
        if (columnRow.kpiReference != refnumber) {
            var answer = getAnswers(
                {
                    'newAnswers': answers,
                    'ref': columnRow.kpiReference,
                    'row': row,
                    'column': column
                })[0];

            value.value = answer?.textValue ?? null;
        }
        else {
            value.value = textValue;
        }
        value.type = {
            2: 'countryID',
            3: 'fuelTypeID',
            4: 'cultureTypeID'
        }[columnRow.type] ?? null;

        if (value.value != null && value.type != null) {
            return value;
        }
        else {
            return null;
        }
    }
    return null;
}

const LinkedTolerancesToValidate = (sskpi, newAnswers, subSectionKPIs, column = null, row = null) => {
    if (subSectionKPIs != null) {
        var linkedKpis = subSectionKPIs.filter(ssk => ssk.toleranceKPILinkedRefNumber?.includes(sskpi.refNumber));

        linkedKpis.map((ssk) => {
            var answer = getAnswers(
                {
                    'newAnswers': newAnswers,
                    'ref': ssk.refNumber,
                    'subSectionKPI': ssk,
                    'row': row,
                    'column': column
                })[0];

            if (answer != null) {
                var answerToBeValited = answersToBeValited.find(x => x.subSectionKPIID == answer.subSectionKPIID
                    && x.column == answer.column
                    && x.row == answer.row);

                if (answerToBeValited == null) {
                    answersToBeValited.push({ 'subSectionKPI': ssk, ...answer })
                }
            }
        })
    }
}

const isEmptyNumericAnswer = (answer) =>
    answer.numberValue == null && (answer.textValue == null || answer.textValue === '');

const setZeroAnswer = (subSectionKPI, newAnswers, rows, columns) => {
    const isSameKpi = (answer) =>
        answer.subSectionKPIID == subSectionKPI.subSectionKPIID &&
        answer.refNumber == subSectionKPI.refNumber;

    // Preserve every existing answer (including its row/column and auxiliary IDs).
    // The previous implementation collapsed all answers for a KPI into one answer,
    // which invalidated multi-row and multi-column forms.
    let updatedAnswers = newAnswers.map(answer =>
        isSameKpi(answer) && isEmptyNumericAnswer(answer)
            ? { ...answer, numberValue: 0, textValue: null }
            : answer
    );

    rows.forEach(row => {
        columns.forEach(column => {
            const hasAnswerForCell = updatedAnswers.some(answer =>
                isSameKpi(answer) && answer.row == row && answer.column == column
            );

            if (!hasAnswerForCell) {
                updatedAnswers.push({
                    subSectionKPIID: subSectionKPI.subSectionKPIID,
                    refNumber: subSectionKPI.refNumber,
                    subSectionID: subSectionKPI.subSectionID,
                    numberValue: 0,
                    textValue: null,
                    comment: null,
                    column,
                    row,
                    file: null
                });
            }
        });
    });

    return updatedAnswers;
}

export const handleAddZeroes = async (event, moduleObject, setModuleObject) => {
    event.preventDefault();

    Swal.fire({
        title: 'Are you sure?',
        text: "This action will add zeros into ALL empty numeric fields in the form. Are you sure you wish to proceed?",
        icon: 'warning',
        showDenyButton: true,
        confirmButtonColor: '#112A61',
        denyButtonColor: '#B0B0BB',
        denyButtonText: 'No',
        confirmButtonText: 'Yes',
        showCloseButton: true
    }).then(async (result) => {
        if (result.isConfirmed) {
            var newAnswers = [...moduleObject.answers];

            moduleObject.data.sections.forEach((section) => {
                section.subSections.forEach((ss) => {
                    const rows = ss.numberOfRows > 1
                        ? [...Array(ss.numberOfRows).keys()]
                        : [null];

                    ss.kpis.forEach((k) => {
                        k.subSectionKPIs.forEach((ssk) => {
                            if (IsNumericType(ssk.unitMeasure)) {
                                const columnRow = moduleObject.columnRows?.find(
                                    x => x.columnRowID == ssk.columnRowID
                                );
                                const numberOfColumns = columnRow?.minimumQuantity > 1
                                    ? columnRow.minimumQuantity
                                    : 1;
                                const columns = numberOfColumns > 1
                                    ? [...Array(numberOfColumns).keys()]
                                    : [null];

                                newAnswers = setZeroAnswer(ssk, newAnswers, rows, columns);
                            }
                        })
                    })
                })
            });

            setModuleObject({ ...moduleObject, answers: newAnswers });
        }
    })

}

const IsNumericType = (type) => {
    return (!['All/Some/None',
        'Always/Sometimes/Never/NA',
        'Always: 100% of the times/Most of the time: over 90% of the times/Sometimes/Occasionally:less than 90% of the times/Never: 0% of the times',
        'Full cost/Subsidised/Free of Charge',
        'Selection from list: All, More than half, Approximaterly half, Less than half, None',
        'Selection from countries list',
        'Selection from housing',
        'Text'].includes(type));
}

const getFilteredAnswers = (type, condition, matchType, answers, moduleObject) => {
    var filteredAnswers = [];

    var types = {
        'Column': 'column',
        'Row': 'row',
        'Culture': 'cultureTypeID',
        'Fuel': 'fuelTypeID',
        'Country': 'countryID',
        'Tobacco': 'cultureTypeID'
    };

    if (type == 'Culture' || type == "Tobacco" || type == 'Fuel' || type == 'Country') {
        condition = getTypeIdsFromName(type, condition, matchType, moduleObject);
    }

    filteredAnswers = answers.filter(x => condition.some(c => c.value == x[types[type]]));

    return filteredAnswers;
}

const getTypeIdsFromName = (type, condition, matchType, moduleObject) => {
    var conditionIds = [];

    var types = {
        'Tobacco': "cultureTypesOptions",
        'Culture': 'cultureTypesOptions',
        'Fuel': 'fuelTypesOptions',
        'Country': 'countriesOptions'
    };

    switch (matchType) {
        case 'Equal':
            conditionIds = moduleObject[types[type]]?.filter(x => x.text?.replaceAll(' ', '') == condition);
            break;

        case 'NotEqual':
            conditionIds = moduleObject[types[type]]?.filter(x => x.text?.replaceAll(' ', '') != condition);
            break;

        case 'StartWith':
            conditionIds = moduleObject[types[type]]?.filter(x => x.text?.replaceAll(' ', '')?.startsWith(condition));
            break;

        case 'EndWith':
            conditionIds = moduleObject[types[type]]?.filter(x => x.text?.replaceAll(' ', '')?.endsWith(condition));
            break;

        case 'Contain':
            conditionIds = moduleObject[types[type]]?.filter(x => x.text?.replaceAll(' ', '')?.includes(condition));
            break;
        default:
            break;
    }

    return conditionIds;
}

export function applyRule(value, rule) {
    rule = rule
        .replace(/\s*<>\s*/, '<>')
        .replace(/\s*<\s*/, '<')
        .replace(/\s*<=\s*/, '<=')
        .replace(/\s*>=\s*/, '>=')
        .replace(/\s*>\s*/, '>');

    if (rule === 'null') {
        return value === '' || value === null;
    }

    if (rule.includes('<') || rule.includes('>') || rule.includes('<>')) {
        let operator, ruleValue;
        if (rule.includes('<>')) {
            operator = '<>';
            ruleValue = rule.split('<>')[1];
        } else if (rule.includes('<')) {
            operator = '<';
            ruleValue = rule.split('<')[1];
        } else if (rule.includes('<=')) {
            operator = '<=';
            ruleValue = rule.split('<=')[1];
        } else if (rule.includes('>=')) {
            operator = '>=';
            ruleValue = rule.split('>=')[1];
        } else {
            operator = '>';
            ruleValue = rule.split('>')[1];
        }
        if (!isNaN(ruleValue)) ruleValue = Number(ruleValue);
        switch (operator) {
            case '<': return value < ruleValue;
            case '>': return value > ruleValue;
            case '>=': return value >= ruleValue;
            case '<=': return value <= ruleValue;
            case '<>': return value !== ruleValue;
        }
    }

    return value == rule;
}

const toggleSubSectionKPIBlock = (subSectionKPIID, setModuleObject) => {
    setModuleObject((prevState) => {
        const isBlocked = prevState.dinamicallyBlockedKpis.includes(subSectionKPIID);

        const updatedBlockedKpis = isBlocked
            ? prevState.dinamicallyBlockedKpis.filter(id => id !== subSectionKPIID)
            : [...prevState.dinamicallyBlockedKpis, subSectionKPIID];

        return {
            ...prevState,
            dinamicallyBlockedKpis: updatedBlockedKpis
        };
    });
};


export const getFieldsToBlock = ({ subSectionKPI = null, subSectionKPIs, refNumbersToBlock = [], row = null, column = null }) => {
    let subSectionKPIsToBlock = [];
    refNumbersToBlock.map(refNumber => {
        let ssk = subSectionKPIs.find(x => x.refNumber == refNumber);
        if (ssk && !subSectionKPIsToBlock.some(x => x.subSectionKPIID == ssk.subSectionKPIID) /*&& (subSectionKPI != null ? ssk.subSectionID == subSectionKPI.subSectionID : true)*/) {
            subSectionKPIsToBlock.push({ ...ssk, row, column })
        }
    });

    return subSectionKPIsToBlock;
}

/**
 * Resolve as linhas do campo de destino, pois a row recebida pertence ao KPI-gatilho.
 * Um gatilho sem row deve afetar todas as linhas quando o destino pertence a uma
 * subsection row-based. Se os metadados da subsection não estiverem disponíveis,
 * mantém o comportamento anterior.
 */
function findSubSectionForDynamicBlock(moduleObject, subSectionID) {
    const sections = moduleObject?.data?.sections || [];
    return sections
        .flatMap(section => section.subSections || [])
        .find(subSection => subSection.subSectionID == subSectionID);
}

export function getRowsToDynamicallyBlock(moduleObject, subSectionKPI, sourceRow = null) {
    const targetSubSection = findSubSectionForDynamicBlock(
        moduleObject,
        subSectionKPI.subSectionID
    );

    if (!targetSubSection) {
        return [sourceRow];
    }

    if (!targetSubSection.isColumnRow) {
        return [null];
    }

    if (sourceRow != null && sourceRow !== undefined) {
        return [sourceRow];
    }

    const numberOfRows = Number(targetSubSection.numberOfRows);
    if (!Number.isInteger(numberOfRows) || numberOfRows <= 0) {
        return [null];
    }

    return Array.from({ length: numberOfRows }, (_, targetRow) => targetRow);
}

export function dynamicallyBlockFields({
    subSectionKPI,
    subSectionKPIs,
    refNumbersToBlock = [],
    disable = false,
    moduleObject,
    row = null,
    column = null,
}) {
    let subSectionKPIsToBlock = getFieldsToBlock({
        subSectionKPI,
        subSectionKPIs,
        refNumbersToBlock,
        row,
        column,
    });

    subSectionKPIsToBlock.forEach(ssk => {
        const targetSubSection = findSubSectionForDynamicBlock(moduleObject, ssk.subSectionID);
        const sourceColumn = ssk.column != null && ssk.column !== undefined ? ssk.column : null;
        const col = targetSubSection?.isColumnRow ? null : sourceColumn;
        const targetRows = getRowsToDynamicallyBlock(moduleObject, ssk, row);

        targetRows.forEach(targetRow => {
            let existentValue = moduleObject.answers.find(
                x =>
                    x.subSectionKPIID === ssk.subSectionKPIID &&
                    x.refNumber === ssk.refNumber &&
                    (targetRow != null && targetRow !== undefined
                        ? x.row == targetRow || (
                            row == null &&
                            targetRow === 0 &&
                            targetRows.length === 1 &&
                            (x.row == null || x.row === undefined)
                        )
                        : true) &&
                    (col != null && col !== undefined ? x.column == col : true)
            );

            let valueExists = !!existentValue;

            let id = `subSectionKPI_${ssk.subSectionKPIID}_${ssk.columnRowID}`;
            if (col != null && col !== undefined) id += `_c${col}`;
            if (targetRow != null && targetRow !== undefined) id += `_r${targetRow}`;

            let elements = document.querySelectorAll(
                `[id="${id}"]:not(.calculation):not([id$=_alert])`
            );

            elements.forEach(el => setElementDisabled(el, disable, valueExists, id));
        });
    });
}

const DEFAULT_MEASURE_TEXT_FONT =
    '400 16px system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

let measureTextWidthCanvas;

/**
 * Largura em pixels do texto numa única linha (canvas), alinhada ao corpo do formulário / react-select.
 * Usado para dimensionar o control do select conforme o rótulo selecionado.
 */
export function measureTextWidthPx(text, font = DEFAULT_MEASURE_TEXT_FONT) {
    if (text == null || text === '') return 0;
    const s = String(text);
    if (typeof document === 'undefined') return s.length * 8;
    if (!measureTextWidthCanvas) {
        measureTextWidthCanvas = document.createElement('canvas');
    }
    const ctx = measureTextWidthCanvas.getContext('2d');
    if (!ctx) return s.length * 8;
    ctx.font = font;
    return ctx.measureText(s).width;
}

export function setElementDisabled(element, disable, paintBorder, id) {
    if (element.localName === 'a') return;
    if (element.localName === 'button') element = element.nextSibling;
    if (element && element.id && element.id.endsWith('_alert')) return;

    element.disabled = disable;

    // react-select (v5): input interno OU (se id duplicado no passado) container com __control — não pintar com alert-input-hasValue;
    // a borda vem do control via blockedValueAlert no FormInput.
    const isInsideReactSelectControl =
        typeof element.closest === 'function' &&
        element.closest('[class*="__control"]');
    if (element.localName === 'input' && isInsideReactSelectControl) {
        element.classList.remove('alert-input-hasValue');
        return;
    }
    const isReactSelectRootDiv =
        element.localName === 'div' &&
        element.id &&
        typeof element.querySelector === 'function' &&
        element.querySelector('[class*="__control"]');
    if (isReactSelectRootDiv) {
        element.classList.remove('alert-input-hasValue');
        return;
    }

    paintBorder && disable
        ? element.classList.add('alert-input-hasValue')
        : element.classList.remove('alert-input-hasValue');
}

const getHighestPlaceholderValue = (expressionMatches) => {
    var matches = expressionMatches.map((match) => {
        return match.replace(/\D/g, '');
    })

    return Math.max(...matches);
}
